<template>
    <v-alert
        :role="overrideAlertRole ? '' : 'alert'"
        :value="value"
        :color="color"
        :outlined="outlined"
        :dismissible="dismissible"
        close-icon="fa fa-times"
        class="xs12 font-weight-bold subheading"
        :class="[ outlineClassName ]">
        <span :class="bgclass" :tabindex="0" v-html="message" />
        <slot />
    </v-alert>
</template>

<script lang="js">

export default {
    name: 'tz-alert',
    props: {
        color: { type: String, required: false, default: 'primary' },
        message: { type: String, required: false, default: '' },
        bgclass: { type: String, required: false, default: 'background-default' },
        outlined: { type: Boolean, required: false, default: false },
        customOutline: { type: Boolean, required: false, default: false },
        dismissible: { type: Boolean, required: false, default: false },
        outlineSuffix: { type: String, required: false, default: '' },
        overrideAlertRole: { type: Boolean, required: false, default: false },
        value: { type: Boolean, required: false, default: true },
    },
    computed: {
        outlineClassName() {
            return this.customOutline ? 'custom-outline' + this.outlineSuffix : '';
        },
    },
};
</script>

<style lang="scss" scoped>
    .kidsTolerances {
        color: #000;
    }
    .background-default {
        color: #fff;
    }
    .custom-outline-warning {
        background-color: #fff;
        border: 4px solid var(--v-warning-base) !important;
    }
    .custom-outline-primary {
        background-color: #fff;
        border: 4px solid var(--v-primary-base) !important;
    }
    .custom-outline {
        background-color: #fff;
        border: 4px solid !important;
    }
</style>
